<div class="deep-dive">
  <!-- Filters — same custom dropdowns as Pricing Action History -->
  <div class="filters">
    <div class="filter" *ngFor="let f of filters">
      <label>{{ f.label }}</label>
      <div class="custom-dropdown">
        <button type="button" class="custom-dropdown-trigger" [title]="getTriggerLabel(f)" (click)="toggleDropdown(f.key, $event)">
          <span class="custom-dropdown-value-label">{{ getTriggerLabel(f) }}</span>
          <span
            *ngIf="hasSelectedValues(f)"
            class="custom-dropdown-remove"
            role="button"
            tabindex="0"
            aria-label="Clear selected values"
            (click)="clearSelectedOptions(f, $event)"
            (keydown.enter)="clearSelectedOptions(f, $event)"
            (keydown.space)="clearSelectedOptions(f, $event)">×</span>
          <span class="custom-dropdown-arrow"></span>
        </button>

        <div class="custom-dropdown-panel" *ngIf="isDropdownOpen(f.key)" (click)="$event.stopPropagation()">
          <input
            class="custom-dropdown-search"
            type="text"
            placeholder="Search"
            autocomplete="off"
            [attr.data-dropdown-search]="f.key"
            [value]="dropdownSearchTerms[f.key]"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
            (input)="setDropdownSearchTerm(f.key, $any($event.target).value)">
          <button
            type="button"
            class="custom-dropdown-option"
            [class.multi]="f.multi"
            *ngFor="let option of getFilteredOptions(f.key)"
            [class.selected]="isOptionSelected(f.key, option)"
            (click)="selectOption(f, option)">
            <span class="option-check" *ngIf="f.multi"></span>
            {{ option }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Graph -->
  <div class="panel">
    <div class="panel-header">{{ chartWidget?.title }}</div>
    <div class="panel-body">
      <div #chart class="chart"></div>
      <div class="empty" *ngIf="!isLoading && filteredRows.length === 0">
        No records match the selected filters.
      </div>
    </div>
  </div>

  <!-- Deep Dive table -->
  <div class="panel">
    <div class="panel-header table-header">
      <span>{{ tableWidget?.title }}</span>
      <button
        type="button"
        class="download-csv-btn"
        aria-label="Download table records as CSV"
        title="Download table records as CSV"
        [disabled]="!canDownloadDeepDive"
        (click)="downloadDeepDiveCsv()">
        <span class="material-icons" aria-hidden="true">cloud_download</span>
      </button>
    </div>
    <div class="panel-body table-wrap">
      <table>
        <thead>
          <tr>
            <th *ngFor="let col of columns">{{ col.label }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredRows">
            <td *ngFor="let col of columns">{{ row[col.key] }}</td>
          </tr>
          <tr *ngIf="!isLoading && filteredRows.length === 0">
            <td [attr.colspan]="columns.length" class="empty-cell">{{ emptyMessage }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
